import dayjs, { type Dayjs } from 'dayjs'
import { endOfDayIso, shiftDay, startOfDayIso, todayInTenantZone } from './format'

/**
 * SANA ORALIG'I — TENANT zonasida, brauzernikida EMAS.
 *
 * <h2>⚠️ Nima uchun bu modul bor</h2>
 * Paneldagi o'nta ekran bir xil ikki ishni qilardi va ikkalasini ham
 * BRAUZER zonasida:
 *
 * <pre>
 *   const [range, setRange] = useState(() => [
 *     dayjs().subtract(7, 'day').startOf('day'),   // "bugundan 7 kun oldin"
 *     dayjs().endOf('day'),                        // "bugun tugaguncha"
 *   ])
 *   const from = range[0].startOf('day').toISOString()
 *   const to = range[1].endOf('day').toISOString()
 * </pre>
 *
 * `dayjs()` brauzerning zonasini oladi. Staging tenanti esa
 * `Asia/Kabul` (UTC+04:30), ish `Asia/Tashkent` (UTC+05:00) dan olib
 * borilyapti — kuniga YARIM SOAT davomida brauzer allaqachon ertangi
 * kunda, tenant esa hali bugungisida. Backend chegarani tenantning
 * `day_timezone` iga qarab hisoblaydi.
 *
 * <h2>⚠️ VA BU JIMGINA</h2>
 * So'rov 200 qaytaradi, jadval to'ladi, xato jurnalida hech narsa yo'q —
 * faqat SON boshqacha bo'ladi. "Hisobotda 3 GB, ro'yxatda 2.4 GB" degan
 * chalkashlik aynan shundan chiqadi va uni ko'z bilan topib bo'lmaydi.
 *
 * <h2>⚠️ Tanlagich qiymati — KALENDAR KUNI, on emas</h2>
 * antd `DatePicker` brauzer zonasidagi `Dayjs` qaytaradi, lekin
 * foydalanuvchi u yerda KO'RGAN sanani tanlaydi. Shuning uchun bu yerda
 * faqat `YYYY-MM-DD` olinadi va u TENANT zonasida onga aylantiriladi:
 * "5-avgust" degani "Kobulda 5-avgust", brauzerda emas.
 */

/** Serverdagi `ReportWindow` bilan bir xil shakl */
const ISO_DAY = 'YYYY-MM-DD'

/** Tenant zonasidagi bugungi kun — sana tanlagichga qo'yish uchun */
export function tenantToday(): Dayjs {
  return dayjs(todayInTenantZone())
}

/**
 * Tenant kalendari bo'yicha bugundan N kun oldingi kun.
 * `tenantDaysAgo(7)` — "oxirgi 7 kun" oynasining chap chekkasi.
 */
export function tenantDaysAgo(days: number): Dayjs {
  return dayjs(shiftDay(todayInTenantZone(), -days))
}

/** Bugundan N kun oldin boshlanadigan, bugun tugaydigan oyna */
export function defaultDayRange(days: number): [Dayjs, Dayjs] {
  return [tenantDaysAgo(days), tenantToday()]
}

export interface IsoRange {
  from: string
  to: string
}

/**
 * Hisobot oynasi — serverdagi `ReportWindow` kutadigan `YYYY-MM-DD` juftligi.
 * `reportWindow(7)` = "oxirgi 7 kun", bugungi kun ham ICHIDA.
 *
 * ⚠️ Bu yerda `Instant` emas, KALENDAR KUNI yuboriladi: zonani serverning
 * o'zi qo'llaydi (`day_timezone`). Bizning ishimiz — "bugun" ni to'g'ri
 * aytish, ya'ni brauzernikini emas, tenantnikini.
 */
export function reportWindow(days: number): IsoRange {
  const to = todayInTenantZone()
  return { from: shiftDay(to, -(days - 1)), to }
}

/**
 * Tanlagich qiymatlarini TENANT zonasidagi kun chegaralariga aylantiradi.
 *
 * ⚠️ `to` — kunning OXIRGI millisekundi (`23:59:59.999`), boshi emas.
 * Aks holda tanlangan oxirgi kun butunlay tushib qolardi va operator
 * buni "kecha ko'proq edi shekilli" deb o'qirdi.
 */
export function rangeToIso(range: readonly [Dayjs, Dayjs]): IsoRange {
  return {
    from: startOfDayIso(range[0].format(ISO_DAY)),
    to: endOfDayIso(range[1].format(ISO_DAY)),
  }
}

/** Ixtiyoriy oraliq: tanlanmagan bo'lsa ikkala chekka ham `null` */
export function optionalRangeToIso(range: readonly [Dayjs, Dayjs] | null | undefined): {
  from: string | null
  to: string | null
} {
  if (!range) return { from: null, to: null }
  return rangeToIso(range)
}
